import asistencia from './asistencia.jpeg';
import deportes from './deportes.jpeg';
import cruceros from './cruceros.jpeg';
import disney from './disney.jpeg';
import circuitos from './circuitos.jpeg';

const products = [
    {
        "title": "ASISTENCIA AL VIAJERO",
        "image": asistencia
    },
    {
        "title": "DEPORTES",
        "image": deportes
    },
    {
        "title": "CRUCEROS",
        "image": cruceros
    },
    {
        "title": "DISNEY",
        "image": disney
    },
    {
        "title": "CIRCUITOS",
        "image": circuitos
    }
];

export default products;
